import React from 'react';
import { Box, Link, Typography } from '@mui/material';

const MessageDisplay = props => {
  return (
    <Box
      sx={{
        height: 'calc(100vh - 75px)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
      }}
    >
      <div>
        {props.blockedMes ? (
          <>
            <Box sx={{ mb: 1 }}>
              <svg
                width="167"
                height="81"
                viewBox="0 0 167 81"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  opacity="0.5"
                  d="M46 73C44.1435 73 42.363 72.2625 41.0503 70.9497C39.7375 69.637 39 67.8565 39 66C39 64.1435 39.7375 62.363 41.0503 61.0503C42.363 59.7375 44.1435 59 46 59H7C5.14348 59 3.36301 58.2625 2.05025 56.9497C0.737498 55.637 0 53.8565 0 52C0 50.1435 0.737498 48.363 2.05025 47.0503C3.36301 45.7375 5.14348 45 7 45H47C48.8565 45 50.637 44.2625 51.9497 42.9497C53.2625 41.637 54 39.8565 54 38C54 36.1435 53.2625 34.363 51.9497 33.0503C50.637 31.7375 48.8565 31 47 31H22C20.1435 31 18.363 30.2625 17.0503 28.9497C15.7375 27.637 15 25.8565 15 24C15 22.1435 15.7375 20.363 17.0503 19.0503C18.363 17.7375 20.1435 17 22 17H62C60.1435 17 58.363 16.2625 57.0503 14.9497C55.7375 13.637 55 11.8565 55 10C55 8.14348 55.7375 6.36301 57.0503 5.05025C58.363 3.7375 60.1435 3 62 3L160 3C161.857 3 163.637 3.7375 164.95 5.05025C166.263 6.36301 167 8.14348 167 10C167 11.8565 166.263 13.637 164.95 14.9497C163.637 16.2625 161.857 17 160 17H120C121.857 17 123.637 17.7375 124.95 19.0503C126.262 20.363 127 22.1435 127 24C127 25.8565 126.262 27.637 124.95 28.9497C123.637 30.2625 121.857 31 120 31H142C143.857 31 145.637 31.7375 146.95 33.0503C148.263 34.363 149 36.1435 149 38C149 39.8565 148.263 41.637 146.95 42.9497C145.637 44.2625 143.857 45 142 45H131.826C126.951 45 123 48.134 123 52C123 55.866 129 59 129 59C130.857 59 132.637 59.7375 133.95 61.0503C135.263 62.363 136 64.1435 136 66C136 67.8565 135.263 69.637 133.95 70.9497C132.637 72.2625 130.857 73 129 73H46ZM153 38C153 36.6155 153.411 35.2622 154.18 34.111C154.949 32.9599 156.042 32.0627 157.321 31.5328C158.6 31.003 160.008 30.8644 161.366 31.1345C162.723 31.4046 163.971 32.0713 164.95 33.0503C165.929 34.0292 166.595 35.2765 166.865 36.6344C167.136 37.9922 166.997 39.3997 166.467 40.6788C165.937 41.9579 165.04 43.0511 163.889 43.8203C162.738 44.5895 161.384 45 160 45C158.143 45 156.363 44.2625 155.05 42.9497C153.737 41.637 153 39.8565 153 38Z"
                  fill="#C9D5E4"
                />
                <svg
                  x="53.125"
                  y="10.125"
                  width="60.75"
                  height="60.75"
                  viewBox="0 0 41 41"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M26.094 26.875C25.0742 31.5869 22.7338 35.9291 19.3342 39.4167C14.6252 34.5861 12.423 28.1708 12.423 21.5C12.423 14.8292 14.6252 8.41398 19.3342 3.58337C15.9449 3.58424 12.6222 4.5027 9.73485 6.2368C6.84751 7.9709 4.50853 10.4528 2.97756 13.407C1.4466 16.3611 0.783545 19.672 1.06201 22.9721C1.34047 26.2721 2.54956 29.4322 4.55505 32.1016C6.56054 34.7709 9.28397 36.8451 12.423 38.0938C15.5621 39.3425 18.9939 39.717 22.3376 39.1756C25.6813 38.6342 28.806 37.1981 31.3648 35.0267C33.9237 32.8554 35.8165 30.0338 36.8333 26.875"
                    stroke="#5397F4"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M1 21.5H17.125"
                    stroke="#5397F4"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M35 10V5.5C35 4.30653 34.4732 3.16193 33.5355 2.31802C32.5979 1.47411 31.3261 1 30 1C28.6739 1 27.4021 1.47411 26.4645 2.31802C25.5268 3.16193 25 4.30653 25 5.5V10"
                    stroke="#5397F4"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M40 11H20V22H40V16.5V11Z"
                    stroke="#5397F4"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </svg>
            </Box>
            <Typography
              variant="h5"
              component="h5"
              fontWeight={600}
              sx={{ mb: '5px' }}
            >
              Service Access Blocked
            </Typography>

            {/* <Typography variant="h6" fontWeight={500} sx={{mb:0.5}}>It looks like your browser or network is blocking access to our service.</Typography> */}

            <Box sx={{ padding: '0px 20px 20px 20px' }}>
              <Typography
                variant="h6"
                fontWeight={500}
                fontSize={'15px'}
                sx={{ mb: 2 }}
              >
                Unable to connect — your browser or network is blocking access.
              </Typography>
              <Typography variant="body2" fontWeight={400} sx={{ mb: 2 }}>
                Please check your ad-blocker, firewall, or browser settings and
                allow access to the following URLs:
              </Typography>
              {props.urlData.map(url => (
                <Typography variant="body2">{url}</Typography>
              ))}
            </Box>
          </>
        ) : (
          <>
            <Box sx={{ mb: 1 }}>
              <svg
                width="167"
                height="81"
                viewBox="0 0 167 81"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  opacity="0.5"
                  d="M46 73C44.1435 73 42.363 72.2625 41.0503 70.9497C39.7375 69.637 39 67.8565 39 66C39 64.1435 39.7375 62.363 41.0503 61.0503C42.363 59.7375 44.1435 59 46 59H7C5.14348 59 3.36301 58.2625 2.05025 56.9497C0.737498 55.637 0 53.8565 0 52C0 50.1435 0.737498 48.363 2.05025 47.0503C3.36301 45.7375 5.14348 45 7 45H47C48.8565 45 50.637 44.2625 51.9497 42.9497C53.2625 41.637 54 39.8565 54 38C54 36.1435 53.2625 34.363 51.9497 33.0503C50.637 31.7375 48.8565 31 47 31H22C20.1435 31 18.363 30.2625 17.0503 28.9497C15.7375 27.637 15 25.8565 15 24C15 22.1435 15.7375 20.363 17.0503 19.0503C18.363 17.7375 20.1435 17 22 17H62C60.1435 17 58.363 16.2625 57.0503 14.9497C55.7375 13.637 55 11.8565 55 10C55 8.14348 55.7375 6.36301 57.0503 5.05025C58.363 3.7375 60.1435 3 62 3L160 3C161.857 3 163.637 3.7375 164.95 5.05025C166.263 6.36301 167 8.14348 167 10C167 11.8565 166.263 13.637 164.95 14.9497C163.637 16.2625 161.857 17 160 17H120C121.857 17 123.637 17.7375 124.95 19.0503C126.262 20.363 127 22.1435 127 24C127 25.8565 126.262 27.637 124.95 28.9497C123.637 30.2625 121.857 31 120 31H142C143.857 31 145.637 31.7375 146.95 33.0503C148.263 34.363 149 36.1435 149 38C149 39.8565 148.263 41.637 146.95 42.9497C145.637 44.2625 143.857 45 142 45H131.826C126.951 45 123 48.134 123 52C123 55.866 129 59 129 59C130.857 59 132.637 59.7375 133.95 61.0503C135.263 62.363 136 64.1435 136 66C136 67.8565 135.263 69.637 133.95 70.9497C132.637 72.2625 130.857 73 129 73H46ZM153 38C153 36.6155 153.411 35.2622 154.18 34.111C154.949 32.9599 156.042 32.0627 157.321 31.5328C158.6 31.003 160.008 30.8644 161.366 31.1345C162.723 31.4046 163.971 32.0713 164.95 33.0503C165.929 34.0292 166.595 35.2765 166.865 36.6344C167.136 37.9922 166.997 39.3997 166.467 40.6788C165.937 41.9579 165.04 43.0511 163.889 43.8203C162.738 44.5895 161.384 45 160 45C158.143 45 156.363 44.2625 155.05 42.9497C153.737 41.637 153 39.8565 153 38Z"
                  fill="#C9D5E4"
                />
                <g clipPath="url(#clip0_913_3758)">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M80.415 0.0926661C80.154 0.128736 79.2641 0.235049 78.4375 0.32918C71.2336 1.14867 63.581 4.46619 57.7385 9.30278C55.6069 11.0672 52.8181 13.9869 51.1807 16.1682C43.6887 26.1484 41.2425 38.5262 44.3509 50.7268C45.0508 53.474 45.7812 55.4207 47.193 58.3019C54.9429 74.118 72.0663 83.1199 89.4815 80.5336C93.6479 79.9148 97.3477 78.7495 101.298 76.8118C105.561 74.7207 108.582 72.5464 112.064 69.0645C115.585 65.5438 117.717 62.5685 119.894 58.1398C121.939 53.9809 123.278 49.4062 123.693 45.1671C123.787 44.21 123.93 43.2082 124.011 42.941C124.2 42.3176 124.204 38.21 124.015 37.848C123.937 37.6969 123.791 36.7588 123.692 35.763C123.013 28.9541 120.207 21.9902 115.722 15.9839C114.26 14.0264 109.952 9.72391 107.975 8.24725C102.275 3.98937 96.0474 1.38376 89.1953 0.389772C87.4832 0.141393 81.5231 -0.0603163 80.415 0.0926661ZM80.8105 2.6236C80.506 2.65904 79.5805 2.7644 78.7539 2.85742C73.4853 3.45116 67.1453 5.80016 62.6172 8.83608C53.4393 14.9895 47.5849 24.1948 45.9002 35.1212C45.5534 37.3701 45.5061 43.1725 45.817 45.3253C47.0707 54.007 50.683 61.3192 56.682 67.3181C62.673 73.3092 70.0045 76.9311 78.6748 78.1832C80.8202 78.4929 86.628 78.4466 88.8789 78.1017C105.907 75.4927 118.838 62.3383 121.177 45.2462C121.481 43.0247 121.439 37.5199 121.102 35.2794C120.467 31.0624 119.247 27.2172 117.364 23.4933C116.008 20.8124 114.849 18.9949 113.081 16.7755C107.183 9.37255 98.3326 4.30736 88.8787 2.9245C87.2758 2.69005 81.9453 2.49118 80.8105 2.6236ZM81.5641 18.6624C77.0268 19.4923 73.4019 22.8548 72.2688 27.2851C71.9966 28.35 71.9512 29.0402 71.9512 32.1198V35.7124L70.8042 35.7872C69.4255 35.8773 68.57 36.2729 67.7945 37.179C67.4909 37.5337 67.1595 38.1234 67.0583 38.4897C66.9258 38.9679 66.8871 41.4951 66.9208 47.4611C66.967 55.63 66.9736 55.7822 67.3234 56.7098C67.9962 58.4932 69.4682 60.2939 70.983 61.1869C71.3642 61.4116 72.1473 61.7789 72.7232 62.0032L73.7705 62.4111L82.8672 62.4582C89.2148 62.4911 92.2912 62.4502 93.0472 62.3227C95.4323 61.9207 97.8508 60.1955 99.0599 58.0333C100.072 56.2233 100.092 56.0259 100.144 46.9864C100.195 37.9667 100.233 38.3425 99.1574 37.1174C98.4295 36.2884 97.5418 35.8792 96.2749 35.7882L95.207 35.7115L95.2029 33.162C95.2007 31.7597 95.1322 29.9361 95.0507 29.1095C94.5734 24.2659 91.4453 20.4564 86.7432 18.9924C85.5005 18.6056 82.8118 18.4343 81.5641 18.6624ZM81.3171 21.361C78.0962 22.2049 75.553 24.7051 74.7158 27.851C74.5482 28.4811 74.4857 29.6642 74.4843 32.234L74.4824 35.754H83.5H92.5176L92.5157 32.234C92.5136 28.3367 92.4133 27.695 91.5331 25.9467C90.8661 24.6219 89.1361 22.8655 87.8212 22.178C86.5783 21.5281 84.6756 21.0386 83.4351 21.0498C82.9053 21.0546 81.9521 21.1947 81.3171 21.361ZM43.0636 40.5001C43.0636 41.8488 43.088 42.4005 43.1175 41.7262C43.1473 41.0519 43.1473 39.9483 43.1175 39.274C43.088 38.5998 43.0636 39.1514 43.0636 40.5001ZM70.0152 38.5329C69.777 38.6621 69.543 38.9263 69.4954 39.1198C69.4476 39.3134 69.4289 43.067 69.4538 47.4611L69.499 55.4503L69.9159 56.3394C70.7023 58.0167 72.1782 59.2592 73.924 59.7139C75.3248 60.0789 91.6751 60.0789 93.076 59.7139C94.8218 59.2592 96.2977 58.0167 97.0841 56.3394L97.501 55.4503L97.5454 47.382C97.5774 41.5672 97.5394 39.219 97.4094 38.975C97.31 38.789 97.0555 38.5575 96.8433 38.4609C96.5703 38.3365 92.6607 38.2872 83.453 38.2916C72.2589 38.2971 70.388 38.3307 70.0152 38.5329ZM82.3472 42.9323C79.9716 43.5952 78.6909 46.4312 79.7707 48.6381C80.2234 49.5636 81.0637 50.4062 81.7844 50.6574L82.2344 50.8143V52.7094C82.2344 54.593 82.2372 54.6074 82.6968 55.067C82.9512 55.3214 83.3125 55.5294 83.5 55.5294C83.6875 55.5294 84.0488 55.3214 84.3032 55.067C84.7626 54.6076 84.7656 54.5922 84.7656 52.718V50.8314L85.4062 50.5425C86.6579 49.9781 87.4644 48.7117 87.5774 47.1333C87.6634 45.9301 87.3589 45.0554 86.5217 44.1019C85.5565 43.0026 83.8297 42.5188 82.3472 42.9323ZM82.9286 45.3952C81.8991 45.8297 81.6213 47.1241 82.3764 47.969C82.7558 48.3937 82.9494 48.4823 83.5 48.4823C84.0505 48.4823 84.2442 48.3937 84.6235 47.969C84.9426 47.6121 85.082 47.2892 85.082 46.9073C85.082 45.8743 83.8476 45.0075 82.9286 45.3952Z"
                    fill="#5397F4"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_913_3758">
                    <rect
                      width="81"
                      height="81"
                      fill="white"
                      transform="translate(43)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </Box>
            {props.unAuthorizedDialoagApi || props.apiError ? (
              <>
                <Typography variant="h6" fontWeight={600} sx={{ mb: 0.5 }}>
                  Access Denied
                </Typography>

                <Typography variant="p">
                  {props.apiError
                    ? 'Something Went Wrong While Calling API. Please Try Again.'
                    : 'Login Session Not Valid'}
                </Typography>
              </>
            ) : (
              <>
                <Typography variant="h6" fontWeight={600} sx={{ mb: 0.5 }}>
                  Access Denied
                </Typography>

                {!props.termsAccepted && (
                  <Typography variant="body1">
                    Please{' '}
                    <Link
                      sx={{ cursor: 'pointer' }}
                      onClick={() => {
                        props.setTermsConditionFlag(true);
                      }}
                    >
                      Accept Terms And Conditions
                    </Link>
                    .
                  </Typography>
                )}

                {/* {!props.guidelinesAccepted && (
                  <Typography variant="body1">
                    Please{" "}
                    <Link
                      sx={{ cursor: "pointer" }}
                      onClick={() => {
                        props.setGuidelinesFlag(true);
                      }}
                    >
                      Accept GuideLines
                    </Link>.
                  </Typography>
                )} */}
              </>
            )}
          </>
        )}
      </div>
    </Box>
  );
};

export default MessageDisplay;
